export {
  mapFhirDiagnosticReportToModel,
  mapModelToFhirDiagnosticReport,
} from './pathologyReport';
